import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IOption, SelectDropdown } from '../../../../components/inputs/select-dropdown/select-dropdown';
import { SingleValue } from 'react-select';
import { PlatformType } from '../../types/action-types';
import PlatformCredentialsForm from '../../components/platform-credentials-forms/platform-credentials-form';

import './create-platform-store-page.scss';

const PLATFORM_OPTIONS: IOption[] = [
    { value: PlatformType.GLOBAL_E, label: 'Global-E' },
    // Add more platforms here in the future
];

const CreatePlatformStorePage: React.FC = observer(() => {
    const [selectedPlatform, setSelectedPlatform] = useState<PlatformType | null>(null);

    const handlePlatformChange = (val: SingleValue<IOption>) => {
        if (val) {
            setSelectedPlatform(val.value as PlatformType);
        } else {
            setSelectedPlatform(null);
        }
    };

    return (
        <div className="create-platform-store-page">
            <div className="card">
                <h4>Create Platform Store</h4>
                <div className="troubleshooting-controls">
                    <p className="head5">Platform <span style={{ color: 'var(--color-accent-3)' }}>*</span></p>
                    <SelectDropdown
                        required
                        value={selectedPlatform ? PLATFORM_OPTIONS.find(opt => opt.value === selectedPlatform) : undefined}
                        options={PLATFORM_OPTIONS}
                        placeholder="Select platform"
                        onChange={handlePlatformChange}
                    />
                </div>
                {selectedPlatform && (
                    <PlatformCredentialsForm platform={selectedPlatform} />
                )}
            </div>
        </div>
    );
});

export default CreatePlatformStorePage;

